<template>
    <div class="desktop-clear-filters">
        <a href="#" @click="removeAllTags" v-if="isThereActiveFilters" class="desktop-clear-filters__link" v-html="$t('CourseListFilter.clear_all_filters')"></a>
        <TotemToast ref="toast" :top="60" />
    </div>
</template>

<script>
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'

    export default {
        name: 'DesktopClearFilters',
        mixins: [filteringHelper],
        inject: ['tab'],
        methods: {
            removeAllTags () {
                this.$store.dispatch(this.getClearAllFilters)
                this.$refs.toast.show(this.$t('CourseListFilter.clear_search_notification'))
            }
        }
    }
</script>

<style scoped lang="scss">
.desktop-clear-filters {
    @include clear-filters;
}
</style>
